export default {
      id: "analyst-star-usage",
      viewBox: "0 0 25 23",
      url: "../../assets/" + "sprite.svg#analyst-star-usage",
      toString: function () {
        return this.url;
      }
    }